<script>
import TheDropdownListContractError from "./TheDropdownListContractError.vue";
import CheckContractServices from "../../../services/CheckContract.services";

export default {
  name: "EffContractTeacherActionDataCard",
  components: {TheDropdownListContractError},

  props: {
    checkBasicBidLength: {
      type: Number,
      default: 0,
    },

    checkBasicHeadDepartmentLength: {
      type: Number,
      default: 0,
    },

    checkBasicDeanLength: {
      type: Number,
      default: 0,
    },

    isSentReview: {
      type: Boolean,
      required: true,
    },

    loadingBtnCalculate: {
      type: Boolean,
      required: true,
    }
  },

  computed: {
    isNotMobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },

    checkedPathsContracts() {
      const bidPath = this.checkBasicBidLength;
      const headDepartmentPath = this.checkBasicHeadDepartmentLength;
      const deanPath = this.checkBasicDeanLength;

      return (bidPath + headDepartmentPath + deanPath) === 0
    },

    isVisibleSentBtn() {
      return this.isSentReview || this.checkedPathsContracts;
    },

    isDate() {
      return CheckContractServices.checkDate();
    },

    disableBtn() {
      return this.isSentReview || !this.isDate
    }
  },
}
</script>

<template>
  <div class="d-flex">
    <v-btn
      to="/effective_contracts/app/order"
      outlined
      color="teal darken-3"
      rounded
      :class="isNotMobile ? 'rounded-xl': ''"
      :fab="isMobile"
      :small="isMobile"
      :disabled="disableBtn"
    >
      <span v-if="isNotMobile">РЕД-ТЬ</span>
      <v-icon small :right="isNotMobile">fa-edit</v-icon>
    </v-btn>
    <span class="mx-2"></span>
    <v-btn
      color="teal darken-3"
      outlined
      class="white--text"
      :class="isNotMobile ? 'rounded-xl': ''"
      :fab="isMobile"
      :small="isMobile"
      :disabled="disableBtn"
      :loading="loadingBtnCalculate"
      @click="$emit('click-auto-calculate')"
    >
      <span v-if="isNotMobile">Переcчитать</span>
      <v-icon small :right="isNotMobile">
        fa-calculator
      </v-icon>
    </v-btn>
    <span class="mx-2"></span>
    <v-btn
      v-if="isVisibleSentBtn"
      color="teal darken-3"
      class="white--text"
      :class="isNotMobile ? 'rounded-xl': ''"
      :fab="isMobile"
      :small="isMobile"
      :disabled="disableBtn"
      @click="$emit('click-send-to-review')"
    >
      <span v-if="isNotMobile">Отправить</span>
      <v-icon small :right="isNotMobile">
        fa-paper-plane
      </v-icon>
    </v-btn>
    <the-dropdown-list-contract-error v-else/>
  </div>
</template>

<style scoped>

</style>